import * as ActionTypes from './EnumTypes/ActionEnumTypes';
import * as VehicleActionModel from './Models/VehicleActionModel';
import * as VehiclesModule from "Modules/VehiclesModule";
import * as ContractModule from '../../Modules/ContractModule';
import * as ViewManagementModule from "Modules/ViewManagementModule";
import * as UserModule from '../../Modules/UserModule';
import {reset, touch} from 'redux-form';
import {history} from 'HelperFunctions/root';
import {Types} from "Models/TerminalInstallationModel";
import {IGetCarsParams, Types as VehicleTypes} from "Models/VehicleModel";
import API, {config, createSerachQuery} from "Connectors/_main";
import {RootState} from "Redux/Reducers/_RootReducer";
import * as ErrorActions from "Redux/Actions/ErrorActions";
import {EnumTypes as ErrorEnumType} from "Models/EnumTypes/ErrorEnumTypes";
import i18n from "Translations/_i18n";
import {DEFAULT_PAGE_SIZE, START_FROM} from "../../constants";
import moment from "moment";
import {initialState} from "Redux/Reducers/VehiclesReducer";
import {Cancel, CancelToken} from "axios";
import {CarCategory, VehicleSpeedEnum} from "Models/EnumTypes/VehicleEnumTypes";
import TurnOffTerminal = Types.TurnOffTerminal;

function getCars(params?: VehicleTypes.VehiclesStore['basicQueryParams'], cancelToken?: CancelToken) {
  //ToDo: abortować gdy przejdzie się na mape
    return async (dispatch, getState: () => RootState) => {
        try {
            const newParams = (params ?? initialState.basicQueryParams)
            const searchParams = new URLSearchParams(newParams as unknown as Record<string, string>)

            dispatch(ViewManagementModule.Actions.showLoader());
            const getCarsResponse = await VehiclesModule.Connector.getCars(searchParams, cancelToken);
            dispatch(setBasicQueryParams(newParams))

            if (newParams.first > 0) {
              const oldVehicles = getState().vehiclesStore.vehiclesList

              getCarsResponse.results = oldVehicles.concat(getCarsResponse.results)
            }

            dispatch(VehiclesModule.Actions.setDetailsForVehile(null));
            dispatch(getCarsSuccess(getCarsResponse.results));
            dispatch(getCarsFilteredSuccess(getCarsResponse));
            // dispatch(filterVehicles(getState().vehiclesStore.tableFilters));
            dispatch(ViewManagementModule.Actions.hideLoader());
        } catch (err) {
            dispatch(ViewManagementModule.Actions.hideLoader());
        }
    };
}

function getCarsFiltered(params: URLSearchParams, noloader?: boolean, filterQuery: boolean = true) {
    return async dispatch => {
        try {
            if (!noloader) {
                dispatch(ViewManagementModule.Actions.showLoader());
            }
            const getCarsResponse = await VehiclesModule.Connector.getCars(params);

            if (filterQuery) {
                dispatch(getCarsFilteredSuccess(getCarsResponse));
            } else {
                dispatch(getCarsLoadNextSuccess(getCarsResponse));
            }

            if (params === null && filterQuery) {
                // dispatch(getCarsTotalListSuccess(getCarsResponse));
                dispatch(this.getCarsSuccess(getCarsResponse.results));
            }

            dispatch(ViewManagementModule.Actions.hideLoader());
        } catch (err) {
            dispatch(ViewManagementModule.Actions.hideLoader());
        }
    };
}

function setActiveVehicle(vehicle: VehiclesModule.Types.CarDto) {
    return async dispatch => {
        try {
            dispatch(VehiclesModule.Actions.setDetailsForVehile(vehicle));
            // todo: jeśli zostanie już naprawione filtrowanie bo numerze umowy to będzie mogło zostać przeniesione do handlera w CarPreviewDetails w setCurrentVin
            dispatch(ContractModule.Actions.setActive(vehicle.contractNumber));
        } catch (e) {
            // console.log(e);
        }
    }
}

function getPartOfVehicles(partList: Array<VehiclesModule.Types.CarDto>): VehicleActionModel.GetPartOfVehiclesAction {
    return {
        type: ActionTypes.Vehicle.GET_PART_OF_VEHICLES,
        payload: {
            partList
        }
    }
}

function resetCarFilteredData() {
    return dispatch => {
        dispatch(this.resetCarFilteredDataSuccess());
    }
}

function resetCarFilteredDataSuccess(): VehicleActionModel.ResetCarFilteredData {
    return {
        type: ActionTypes.Vehicle.RESET_CAR_FILTERED_DATA
    }
}

function addCar(carData: VehiclesModule.Types.AddCarRequest) {
    return async dispatch => {
        try {
            const addCarResult = await VehiclesModule.Connector.addCar(carData);
            dispatch(addCarSuccess());
            await dispatch(reset('addCarForm'));
            history.push(`cars/${addCarResult.data.id}`);
            await dispatch(getCars());
        } catch (err) {
            //TODO obsluga bledow
            dispatch(addCarFailure(err && err.response ? err.response.data : null));
        }
    };
}

function setCarName(carName: string, carId: number) {
    return async dispatch => {
        try {
            await VehiclesModule.Connector.addCarName(carName, carId);
            dispatch(setCarNameSuccess());
            await dispatch(getCars());
        } catch (err) {
            // dispatch(setCarNameSuccess());
        }
    };
}

function getSingleCarDetails(carId: number, getWithInfo: boolean = false) {
    // const signal = axiosCancelToken.source();
    return async dispatch => {
        let mergedResponse: VehicleTypes.CarResponse = null;
        try {
            dispatch(ViewManagementModule.Actions.showDetailsSidebarLoader());
            // signal.cancel('Test');
            const carResponse = await VehiclesModule.Connector.getSingleCarDetails(carId);
            if (getWithInfo) {
                const infoResponse = await VehiclesModule.Connector.getSingleCarLastTravel(carId);
                mergedResponse = {car: carResponse.data, ...infoResponse.data};
            } else {
                mergedResponse = {car: carResponse.data};
            }
            await dispatch(getSingleCarDetailsSuccess(mergedResponse));
            dispatch(ViewManagementModule.Actions.hideDetailsSidebarLoader());
        } catch (err) {
            dispatch(ViewManagementModule.Actions.hideDetailsSidebarLoader());
        }
    };
}

function getSingleCarDistanceWeek(carId: number) {
    return async dispatch => {
        try {
            const response = await VehiclesModule.Connector.getSingleCarWeekMileage(carId);
            dispatch(getSingleCarAdditionalInfoSuccess(response.data));
        } catch (e) {
            console.log(e);
        }
    }
}

function getSingleCarDistanceMonth(carId: number) {
    return async dispatch => {
        try {
            const response = await VehiclesModule.Connector.getSingleCarMonthMileage(carId);
            dispatch(getSingleCarAdditionalInfoSuccess(response.data));
        } catch (e) {
            console.log(e);
        }
    }
}

function uploadCarImage(carId: number, submitData: any) {
    return async dispatch => {
        try {
            const formData = new FormData();
            formData.append('main', submitData.main);
            formData.append('file', submitData.file);
            dispatch(ViewManagementModule.Actions.showLoader());
            await VehiclesModule.Connector.addCarImage(carId, formData);
            dispatch(reset('addCarPhotoForm'));
            dispatch(ViewManagementModule.Actions.hideLoader());
            dispatch(uploadCarImageSuccess());
            await dispatch(getCarImages(carId));
        } catch (err) {
            //
            dispatch(ViewManagementModule.Actions.hideLoader());
        }
    };
}

function getCarImages(carId: number) {
    return async dispatch => {
        try {
            const photosResponse = await VehiclesModule.Connector.getSingleCarImages(carId);
            dispatch(getCarImagesSuccess(photosResponse.data.photos));
        } catch (err) {
            //
        }
    };
}

function deleteCarImage(guid: string, carId: number) {
    return async dispatch => {
        try {
            dispatch(ViewManagementModule.Actions.showLoader());
            await VehiclesModule.Connector.deleteImage(guid);
            await dispatch(getCarImages(carId));
            dispatch(deleteCarImageSuccess());
            dispatch(ViewManagementModule.Actions.hideLoader());
        } catch (err) {
            //
            dispatch(ViewManagementModule.Actions.hideLoader());
        }
    };
}

function getCarById(carId: number) {
    return async dispatch => {
        try {
            dispatch(ViewManagementModule.Actions.showLoader());
            const response = await VehiclesModule.Connector.getCarById(carId);
            dispatch(setDetailsForVehile(response.data.car));
            dispatch(ViewManagementModule.Actions.hideLoader());
        } catch (err) {
            dispatch(ViewManagementModule.Actions.hideLoader());
        }
    };
}

// SUCCESS | FAILURE ACTIONS
function setDetailsForVehile(vehicle: VehiclesModule.Types.CarDto): VehicleActionModel.SetDetailsForVehicleView {
    return {
        type: ActionTypes.Vehicle.SET_DETAILS_FOR_VEHILE_VIEW,
        payload: {
            vehicle
        }
    };
}

function addCarSuccess(): VehicleActionModel.AddCarSuccessAction {
    return {
        type: ActionTypes.Vehicle.ADD_CAR_SUCCESS
    };
}

function getCarsFilteredSuccess(vehiclesListFiltered: VehiclesModule.Types.PaginatedListCarDto): VehicleActionModel.GetFilteredCarsSuccess {
    return {
        type: ActionTypes.Vehicle.GET_FILTERED_CARS_SUCCESS,
        payload: {
            vehiclesListFiltered
        }
    };
}

// function getCarsTotalListSuccess(vehicleslList: Array<VehiclesModule.Types.CarDto>): VehicleActionModel.GetTotalListCarsSuccess {
//     // jeśli nie ma paginacji to pobiera całość tak czy siak. Dobrze żeby trzymało całość bo ewentualny reset
//     // filtrów nie bedzie wymagał ponownego requesta
//     return {
//         type: ActionTypes.Vehicle.GET_TOTAL_LIST_CARS_SUCCESS,
//         payload: {
//             vehicleslList
//         }
//     };
// }

function getCarsLoadNextSuccess(vehiclesList: VehiclesModule.Types.PaginatedListCarDto): VehicleActionModel.GetLoadNextCarsSuccess {
    return {
        type: ActionTypes.Vehicle.GET_CARS_NEXT_SUCCESS,
        payload: {
            vehiclesList
        }
    };
}

function addCarFailure(error: UserModule.Types.Error): VehicleActionModel.AddCarFailureAction {
    return {
        type: ActionTypes.Vehicle.ADD_CAR_FAILURE,
        payload: {
            error
        }
    };
}

function setCarNameSuccess(): VehicleActionModel.SetCarNameSuccessAction {
    return {
        type: ActionTypes.Vehicle.SET_CAR_NAME_SUCCESS
    };
}

function setCarNameFailure(error: UserModule.Types.Error): VehicleActionModel.SetCarNameFailureAction {
    return {
        type: ActionTypes.Vehicle.SET_CAR_NAME_FAILURE,
        payload: {
            error
        }
    };
}

function getSingleCarDetailsSuccess(singleCarViewData: VehiclesModule.Types.CarResponse): VehicleActionModel.GetSingleCarDetailsSuccess {
    return {
        type: ActionTypes.Vehicle.GET_SINGLE_CAR_DETAILS_SUCCESS,
        payload: {
            singleCarViewData
        }
    };
}

function getSingleCarAdditionalInfoSuccess(singleCarViewData: VehiclesModule.Types.CarResponse): VehicleActionModel.GetSingleCarAdditionalInfoSuccess {
    return {
        type: ActionTypes.Vehicle.GET_SINGLE_CAR_ADDITIONAL_INFO,
        payload: {
            singleCarViewData
        }
    };
}

function getCarsSuccess(vehiclesList: Array<VehiclesModule.Types.CarDto>): VehicleActionModel.InitializeVehiclesAction {
    return {
        type: ActionTypes.Vehicle.INITIALIZE_VEHICLES,
        payload: {
            vehiclesList
        }
    };
}

function uploadCarImageSuccess(): VehicleActionModel.UploadCarImageSuccess {
    return {
        type: ActionTypes.Vehicle.UPLOAD_CAR_IMAGE_SUCCESS
    };
}

function getCarImagesSuccess(images: VehiclesModule.Types.CarPhotoDto): VehicleActionModel.GetCarImagesSuccess {
    return {
        type: ActionTypes.Vehicle.GET_SINGLE_CAR_IMAGES_SUCCESS,
        payload: {
            images
        }
    };
}

function deleteCarImageSuccess(): VehicleActionModel.DeleteCarImageSuccess {
    return {
        type: ActionTypes.Vehicle.DELETE_CAR_IMAGE_SUCCESS
    };
}

function updateCarLatestDataframe(dataframe: VehiclesModule.Types.CarDataframeDto, carId: number): VehicleActionModel.UpdateCarLatestDataframe {
    return {
        type: ActionTypes.Vehicle.UPDATE_CAR_LATEST_DATAFRAME,
        payload: {
            dataframe,
            carId
        }
    };
}

function openSSEdiagnosticSuccess(): VehicleActionModel.OpenWSSdiagnosticSuccess {
    return {
        type: ActionTypes.Vehicle.OPEN_SSE_DIAGNOSTIC_SUCCESS
    };
}

function turnOffCar(formData: any) {
    return async dispatch => {
        try {
            const carId: number = formData.carId;
            const turnOffDate = formData.turnOffDate.format('YYYY-MM-DD');
            const turnOffData: TurnOffTerminal = {
                turnOffDate,
                turnOffReason: formData.turnOffReason.value,
                turnOffNote: formData.turnOffNote
            };
            await VehiclesModule.Connector.turnOffCar(carId, turnOffData);
            dispatch(toggleCarTurned(turnOffData));
        } catch (err) {
            //
        }
    };
}

function turnOnCar(carId: number) {
    return async dispatch => {
        try {
            await VehiclesModule.Connector.turnOnCar(carId);
            dispatch(toggleCarTurned(null));
        } catch (err) {
            //
        }
    };
}

function turnOffSim(msisdn: string) {
    return async dispatch => {
        try {
            await VehiclesModule.Connector.turnOffSim(msisdn);
            await dispatch(getCars());
        } catch (err) {
            //
        }
    };
}

function toggleCarTurned(data: TurnOffTerminal): VehicleActionModel.toggleCarTurned {
    return {
        type: ActionTypes.Vehicle.SET_TURN_OFF_CAR_DATE,
        payload: {
            turnOffData: data
        }
    };
}

function saveSearchQuery(queryParams: URLSearchParams) {
  return {
    type: ActionTypes.Vehicle.SAVE_SEARCH_QUERY,
    payload: {
      queryParams
    }
  }
}

function updateRequestHasError(hasRqError: boolean) {
  return {
    type: ActionTypes.Vehicle.UPDATE_REQUEST_HAS_ERROR,
    payload: {
      hasRqError
    }
  }
}

function clearSearchMeta() {
  return {
    type: ActionTypes.Vehicle.CLEAR_SEARCH_META,
  }
}

function updateHasSearched(hasSearched) {
  return {
    type: ActionTypes.Vehicle.UPDATE_HAS_SEARCHED,
    payload: {
      hasSearched
    }
  }
}

function cacheSearchedVehicles(searchedVehicles: VehiclesModule.Types.PaginatedListCarDto) {
  return {
    type: ActionTypes.Vehicle.CACHE_SEARCHED_VEHICLES,
    payload: {
      searchedVehicles
    }
  }
}

function initSearchedVehiclesActionCreator() {
  return {
    type: ActionTypes.Vehicle.INIT_SEARCHED_VEHICLES,
  }
}

function initSearchedVehicles() {
  return (dispatch, getState: () => RootState) => {
    dispatch(initSearchedVehiclesActionCreator())
    dispatch(filterSearchedVehicles(getState().vehiclesStore.tableSearchFilters))
  }
}

function restoreFilteredSearchedVehicles() {
  return {
    type: ActionTypes.Vehicle.RESTORE_FILTERED_SEARCHED_VEHICLES,
  }
}

// ToDo: wynieść do utilów
function preparePaginatedList<T>(data: T[] = [], max: number = DEFAULT_PAGE_SIZE) {
  const fakeRowsCount = 10 // Potrzebne do ładnego wyświetlenia empty state w tabelce

  return {
    results: data,
    totalCount: data.length < fakeRowsCount ? fakeRowsCount : data.length,
    first: data.length < fakeRowsCount ? fakeRowsCount : data.length,
    max: data.length < fakeRowsCount ? fakeRowsCount : max
  }
}

function setIsSearching(isSearching: boolean) {
  return {
    type: ActionTypes.Vehicle.SET_IS_SEARCHING,
    payload: {
      isSearching
    }
  }
}

function search(query?: string, resetFirst?: boolean, shouldListStayHide?: boolean) {
  return async (dispatch, getState: () => RootState) => {
    dispatch(setIsSearching(true))
    try {
      const params = new URLSearchParams()
      const hasEmptyQuery = query === ''
      const { queryParams: oldParams } = getState().vehiclesStore

      /**
       * query jest undefined tylko w momencie wywołania ponownego wyszukania po upłynięciu konkretnego czasu,
       * zatem nie uwzględniam go w zmiennej _hasEmptyQuery_
       */
      if (typeof query == 'undefined') {
        params.append('search', oldParams.get('search'))
        params.append('first', `${START_FROM}`)
        params.append('max', Number(oldParams.get('first')) === 0
          ? `${DEFAULT_PAGE_SIZE}`
          : oldParams.get('first')
        )
      } else {
        params.append('search', query)
        params.append('first', hasEmptyQuery || resetFirst
          ? `${START_FROM}`
          : `${Number(oldParams.get('first')) + DEFAULT_PAGE_SIZE}`
        )
        params.append('max', `${DEFAULT_PAGE_SIZE}`)

        dispatch(saveSearchQuery(params))
      }

      const getCarsResponse = hasEmptyQuery
        ? preparePaginatedList<VehiclesModule.Types.CarDto>()
        : await VehiclesModule.Connector.fetchFilteredCars(params)

      if (Number(params.get('first')) > 0) {
        const oldVehicles = getState().vehiclesStore.searchedVehicles.results

        getCarsResponse.results = oldVehicles.concat(getCarsResponse.results)
      }

      dispatch(cacheSearchedVehicles(getCarsResponse))
      dispatch(updateHasSearched(true))
      dispatch(filterSearchedVehicles(hasEmptyQuery ? [] : getState().vehiclesStore.tableSearchFilters))

      const {viewManagementStore, vehiclesStore} = getState()

      if (!viewManagementStore.vehicleListVisible && !shouldListStayHide) {
        dispatch(ViewManagementModule.Actions.showVehicleList())
      }
      if (vehiclesStore.hasRqError) {
        dispatch(updateRequestHasError(false))
      }
    } catch (e) {
      if (e?.response?.status?.toString().match(/^[45]/g)) {
        dispatch(updateRequestHasError(true))
      }
      console.error(e)
      console.log({...e })
    } finally {
      dispatch(setIsSearching(false))
    }
  }
}

export interface IDateRangeParams {
  startDate: moment.Moment
  endDate: moment.Moment
}

function downloadTraceHistoryToXLSX(dateRange?: IDateRangeParams) {
  //ToDo: wrzucić typy reduxa
  return async (dispatch: any, getState: () => RootState) => {
    if (!dateRange) {
      await dispatch(touch('searchRidesForm', 'dateRange'))
    }

    const {
      form: {
        searchRidesForm,
        latestDataframesForm
      }
    } = getState()

    if (searchRidesForm?.syncErrors || latestDataframesForm?.syncErrors) {
      return
    }

    const {
      vehiclesStore: {
        activeVehicleDetails
      }
    } = getState()

    const formValues = searchRidesForm?.values ?? latestDataframesForm.values
    const dateRangeParams = dateRange ? { dateRange } : formValues

    try {
      await API.post(
        `report/cars/${activeVehicleDetails.id}/rides`,
        null,
        config(createSerachQuery(dateRangeParams))
      )

      dispatch(ErrorActions.setNewsForMoment({
        type: ErrorEnumType.NewsType.SUCCESS,
        message: i18n.t('forms:SUCCESS_SEND_REQUEST_FOR_DOWNLOAD_XLSX_TRACE')
      }));
    } catch (e) {
      console.error(e)
    }
  }
}

function saveSearchedFilters(filters: VehicleTypes.VehiclesStore['tableSearchFilters']) {
  return {
    type: ActionTypes.Vehicle.SAVE_SEARCHED_FILTERS,
    payload: { filters }
  }
}
function saveFilters(filters: VehicleTypes.VehiclesStore['tableFilters']) {
  return {
    type: ActionTypes.Vehicle.SAVE_FILTERS,
    payload: { filters }
  }
}

function restoreFilteredVehicles() {
  return {
    type: ActionTypes.Vehicle.RESTORE_FILTERED_VEHICLES,
  }
}

function filterSearchedVehicles(newFilters: VehicleTypes.VehiclesStore['tableSearchFilters'], column?: any, value?: any) {
  return (dispatch: any, getState: () => RootState) => {
    dispatch(saveSearchedFilters(newFilters))
    if (newFilters.length === 0) {
      dispatch(restoreFilteredSearchedVehicles())
      return

    }

    const filters = [...newFilters]

    const { vehiclesStore: { searchedVehicles} } = getState()

    const newFilteredList: typeof searchedVehicles= {
      ...searchedVehicles,
      results: [...searchedVehicles.results],
    }

    filters.forEach((columnFilter) => {
      const isCategoryAndSpeedLimitFilter = columnFilter.id === "carCategory&speedLimitExceedance"

      if (isCategoryAndSpeedLimitFilter
        && columnFilter.value.speedLimitExceedance.length === 0
        && columnFilter.value.carCategory.length === 0) {
        return true
      }

      newFilteredList.results = newFilteredList.results
        .filter((vehicle) => {
          if (isCategoryAndSpeedLimitFilter) {
            const hasCategory = columnFilter.value.carCategory.includes(vehicle.carCategory)
            const isIncludesSpeedLimit = columnFilter.value.speedLimitExceedance.includes(vehicle.speedLimitExceedance)

            return hasCategory || isIncludesSpeedLimit
          }


          return (
            vehicle[columnFilter.id]
              .toLowerCase()
              .includes(columnFilter.value.toLowerCase())
          );
        })
    })

    dispatch(getCarsFilteredSuccess(newFilteredList))
  }
}

function filterVehicles(newFilters: VehicleTypes.VehiclesStore['tableFilters'], column?: any, value?: any, cancelToken?: CancelToken) {
  return (dispatch: any, getState: () => RootState) => {
    const actualFilters = getState().vehiclesStore.tableFilters

    if (
      newFilters.length >= actualFilters.length
      && newFilters.every((filter) => actualFilters.find((actualFilter) => actualFilter.id === filter.id)?.value === filter.value)
    ) {
      return
    }


    dispatch(saveFilters(newFilters))
    if (newFilters.length === 0) {
      dispatch(getCars(undefined, cancelToken))
      return

    }

    const params = newFilters.reduce((allParams, filter) => {
      if (filter.id === 'vin') {
        return { ...allParams, vin: filter.value}
      }
      if (filter.id === 'licensePlate') {
        return { ...allParams, license_plate: filter.value}
      }
      if (filter.id === 'model') {
        return { ...allParams, model: filter.value}
      }
      if (filter.id === 'carCategory&speedLimitExceedance') {
        return { ...allParams, car_category: filter.value.carCategory, speed_exceedances: filter.value.speedLimitExceedance}
      }

      return allParams
    }, {
      first: initialState.basicQueryParams.first,
      max: getState().vehiclesStore.basicQueryParams.max
    })

    dispatch(getCars(params, cancelToken))
  }
}

function resetSucceed() {
  return {
    type: ActionTypes.Vehicle.RESET_SUCCEED
  }
}

function resetInit() {
  return {
    type: ActionTypes.Vehicle.RESET_INIT
  }
}

function setBasicQueryParams(basicQueryParams: VehicleTypes.VehiclesStore['basicQueryParams']) {
  return {
    type: ActionTypes.Vehicle.SET_BASIC_QUERY_PARAMS,
    payload: {
      basicQueryParams
    }
  }
}

function clearVehiclesList() {
  return {
    type: ActionTypes.Vehicle.INITIALIZE_VEHICLES,
    payload: { vehiclesList: [] }
  }
}

function searchCarById(id: string | number) {
  return async (dispatch, getState: () => RootState) => {
    try {
      const { activeFleet } = getState().fleetStore
      const foundCar = activeFleet?.cars?.find((car) => car.id.toString() === id.toString())
      const { queryParams } = getState().vehiclesStore

      if (!foundCar) {
        queryParams.set('search', '')
        dispatch(saveSearchQuery(queryParams))
        return
      }

      queryParams.set('search', foundCar.vin ?? foundCar.licensePlate)
      dispatch(saveSearchQuery(queryParams))
      dispatch(updateHasSearched(true))
      dispatch(cacheSearchedVehicles(preparePaginatedList([foundCar])))
      dispatch(ViewManagementModule.Actions.showVehicleList())

    } catch (e) {
      console.error(e)
      console.log({...e })
    }
  }
}

export {
    setDetailsForVehile,
    openSSEdiagnosticSuccess,
    updateCarLatestDataframe,
    getCars,
    addCar,
    setCarName,
    getSingleCarDetails,
    getSingleCarDistanceWeek,
    getSingleCarDistanceMonth,
    uploadCarImage,
    getCarImages,
    deleteCarImage,
    getCarsFiltered,
    getCarsSuccess,
    getCarImagesSuccess,
    getSingleCarDetailsSuccess,
    resetCarFilteredData,
    resetCarFilteredDataSuccess,
    getPartOfVehicles,
    getCarsFilteredSuccess,
    turnOffCar,
    turnOnCar,
    turnOffSim,
    setActiveVehicle,
    getCarById,
    toggleCarTurned,
    getCarsLoadNextSuccess,
    search,
    clearSearchMeta,
    initSearchedVehicles,
    preparePaginatedList,
    downloadTraceHistoryToXLSX,
    filterSearchedVehicles,
  resetSucceed,
  resetInit,
  clearVehiclesList,
  filterVehicles,
  searchCarById,
  // openWSSWithCarDiagnostic
};



// WEBPACK FOOTER //
// ./src/Redux/Actions/VehicleActions.ts